import { userComments } from '@/mocks/home';

export default function UserComments() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-lg bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              网友热议区
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight">
              千万网友
              <br />
              在线吃瓜
            </h2>
          </div>

          <div className="columns-1 md:columns-2 lg:columns-3 gap-5 md:gap-6">
            {userComments.map((comment) => (
              <div
                key={comment.id}
                className="break-inside-avoid mb-5 md:mb-6 bg-background-50 border border-background-200/70 rounded-2xl p-5 md:p-6 hover:border-accent-200/50 transition-colors"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <span className="font-heading text-accent-600 text-sm">{comment.avatar}</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">{comment.name}</p>
                    <p className="text-xs text-foreground-400">{comment.handle}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  &ldquo;{comment.comment}&rdquo;
                </p>
                <div className="mt-4 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-heart-line"></i>
                  <span>{comment.likes}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}